$(function() {
    $('.js-validate-login').validate({
        errorElement: 'div',
        errorClass: 'label__error',
        focusInvalid: true,

        highlight: function(element, errorClass) {
            const { form, id, name } = element;

            if (!id && !name) return;

            const errorBlock = $(form).find(`div[for=${id ? id : name}]`);

            $(element).closest('.js-label').addClass('has-error');

            $(errorBlock).addClass(errorClass);
        },

        unhighlight: function(element, errorClass) {
            const { form, id, name } = element;

            if (!id && !name) return;

            const errorBlock = $(form).find(`div[for=${id ? id : name}]`);

            $(element).closest('.js-label').removeClass('has-error');

            $(errorBlock).removeClass(errorClass);
        },
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/validation.js